
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ember-apollo-1-getting-started.json") })
        }
      }, "path---ember-apollo-1-getting-started");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---ember-apollo-1-getting-started!./.cache/json/ember-apollo-1-getting-started.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---ember-apollo-1-getting-started!./.cache/json/ember-apollo-1-getting-started.json
// module chunks = 154